import { MatxSuspense } from "app/components";
import useSettings from "app/hooks/useSettings";
import { MatxLayoutsOther } from "./index";

export default function MatxLayout(props) {
  const { settings } = useSettings();
  const Layout = MatxLayoutsOther[settings.activeLayout];

  return (
    <MatxSuspense>
      <Layout {...props} />
    </MatxSuspense>
  );
}
